import React from "react";
// Fluent IU
import { Modal } from "@fluentui/react";
// Our modules
import TwoFA from "./TwoFA";

export default function MfaModal(props) {
  const { isOpen, setIsOpen, store } = props;
  const { mfaTypes } = store.state;

  const handleDismiss = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onDismiss={handleDismiss} isBlocking={false}>
      <TwoFA store={store} handleDismiss={handleDismiss} options={mfaTypes} />
    </Modal>
  );
}
